import { render, staticRenderFns } from "./dininghall.vue?vue&type=template&id=3edae32e"
import script from "./dininghall.vue?vue&type=script&lang=js"
export * from "./dininghall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3edae32e')) {
      api.createRecord('3edae32e', component.options)
    } else {
      api.reload('3edae32e', component.options)
    }
    module.hot.accept("./dininghall.vue?vue&type=template&id=3edae32e", function () {
      api.rerender('3edae32e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/dininghall.vue"
export default component.exports